module.exports = __webpack_public_path__ + "img/6.d8b6e0f1.jpeg";